const ko = {
  ID_CHAT_MENU_PROFILE: "프로필 보기",
  ID_CHAT_MENU_REPORT: "채팅 신고",
  ID_CHAT_MENU_BLOCK: "유저 차단",
  ID_CHAT_INPUT_PLACEHOLDER: "친구에게 말을 걸어보세요.",

  ID_WORLD_CHAT_POPUP_TITLE: "월드 채팅 메세지",
  ID_WORLD_CHAT_POPUP_PLACEHOLDER: "월드 메세지를 입력해 보세요.",
  ID_WORLD_CHAT_POPUP_CONFIRM: "보내기",

  ID_INVALIDATION_BAD_WORD_1ST:
    "[시스템] 금칙어 1차 경고: 금칙어가 5회 누적되어 5분간 채팅을 할 수 없습니다. ({ttl} 남음)",
  ID_INVALIDATION_BAD_WORD_2ST:
    "[시스템] 금칙어 2차 경고: 금칙어 1차 경고가 3회 누적되어 24시간 동안 채팅을 할 수 없습니다. ({ttl} 남음)",
  ID_INVALIDATION_REPORT_WORD_1ST:
    "[시스템] 채팅 1차 경고: 채팅 신고가 5회 누적되어 5분간 채팅을 할 수 없습니다. ({ttl} 남음)",
  ID_INVALIDATION_REPORT_WORD_2ST:
    "[시스템] 채팅 2차 경고: 채팅 1차 경고가 3회 누적되어 24시간 동안 채팅을 할 수 없습니다. ({ttl} 남음)",
  ID_INVALIDATION_WORLD_CHAT_COOL_TIME:
    "[시스템] 월드 채팅을 사용하기까지 시간이 필요합니다. ({ttl}초 남음)",
  ID_INVALIDATION_NOT_USER_EXIST: "[시스템] 월드 내에 해당 사용자가 없습니다",
  ID_INVALIDATION_CONNECTION_ERROR:
    "[시스템] 채팅이 끊겼습니다. 새로고침 후 다시 시도해주세요.",

  ID_FLOATING_NOTI_REPORT: "신고를 완료했어요",
  ID_FLOATING_NOTI_BLOCK: "{user}님을 차단했어요",

  ID_DROP_MENU_PLAY: "Play",
  ID_DROP_MENU_AVATAR: "Avatar",
  ID_DROP_MENU_STUDIO: "Studio",
  ID_DROP_MENU_SOCIAL: "Social",
  ID_SEARCH_POPUP_START_CHAT: "채팅 시작",
  ID_SEARCH_NO_DATA: "검색 결과가 없어요.",
  ID_SEARCH_INPUT_PLACEHOLDER: "검색",

  ID_PRIVATE_CHAT_PLACEHOLDER_WORLD: "월드 내 유저가 없어요",
  ID_PRIVATE_CHAT_PLACEHOLDER_FOLLOWERS: "팔로워 유저가 없어요",
  ID_PRIVATE_CHAT_PLACEHOLDER_FOLLOWING: "팔로잉 유저가 없어요",
  ID_PRIVATE_CHAT_MESSAGE_OPTION: "일반",

  ID_WORLD_PLAY_DROP_MENU_NOTICE: "Notice",
  ID_WORLD_PLAY_DROP_MENU_EXIT: "Exit",
  ID_CHAT_REPORT_REASON_INSULT: "폭언 욕설",
  ID_CHAT_REPORT_REASON_OBSCENE: "음란 채팅",
  ID_CHAT_REPORT_REASON_AD: "광고",
  ID_CHAT_REPORT_REASON_ABUSE: "채팅 도배",
  ID_CHAT_REPORT_REASON_FALSE_DISSEMINATION: "허위 유포",
};

export default ko;
